/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_business } from './communication/business.icon';
import { icon_call } from './communication/call.icon';
import { icon_call_end } from './communication/call_end.icon';
import { icon_call_merge } from './communication/call_merge.icon';
import { icon_call_made } from './communication/call_made.icon';
import { icon_call_missed } from './communication/call_missed.icon';
import { icon_call_missed_outgoing } from './communication/call_missed_outgoing.icon';
import { icon_call_received } from './communication/call_received.icon';
import { icon_chat } from './communication/chat.icon';
import { icon_chat_bubble_outline } from './communication/chat_bubble_outline.icon';
import { icon_chat_bubble } from './communication/chat_bubble.icon';
import { icon_call_split } from './communication/call_split.icon';
import { icon_contact_phone } from './communication/contact_phone.icon';
import { icon_comment } from './communication/comment.icon';
import { icon_dialer_sip } from './communication/dialer_sip.icon';
import { icon_email } from './communication/email.icon';
import { icon_contacts } from './communication/contacts.icon';
import { icon_dialpad } from './communication/dialpad.icon';
import { icon_import_contacts } from './communication/import_contacts.icon';
import { icon_contact_mail } from './communication/contact_mail.icon';
import { icon_clear_all } from './communication/clear_all.icon';
import { icon_forum } from './communication/forum.icon';
import { icon_import_export } from './communication/import_export.icon';
import { icon_location_on } from './communication/location_on.icon';
import { icon_invert_colors_off } from './communication/invert_colors_off.icon';
import { icon_live_help } from './communication/live_help.icon';
import { icon_mail_outline } from './communication/mail_outline.icon';
import { icon_message } from './communication/message.icon';
import { icon_phone } from './communication/phone.icon';
import { icon_no_sim } from './communication/no_sim.icon';
import { icon_location_off } from './communication/location_off.icon';
import { icon_phonelink_setup } from './communication/phonelink_setup.icon';
import { icon_phonelink_erase } from './communication/phonelink_erase.icon';
import { icon_phonelink_ring } from './communication/phonelink_ring.icon';
import { icon_present_to_all } from './communication/present_to_all.icon';
import { icon_phonelink_lock } from './communication/phonelink_lock.icon';
import { icon_ring_volume } from './communication/ring_volume.icon';
import { icon_portable_wifi_off } from './communication/portable_wifi_off.icon';
import { icon_rss_feed } from './communication/rss_feed.icon';
import { icon_stay_current_portrait } from './communication/stay_current_portrait.icon';
import { icon_screen_share } from './communication/screen_share.icon';
import { icon_speaker_phone } from './communication/speaker_phone.icon';
import { icon_stay_current_landscape } from './communication/stay_current_landscape.icon';
import { icon_stay_primary_landscape } from './communication/stay_primary_landscape.icon';
import { icon_stay_primary_portrait } from './communication/stay_primary_portrait.icon';
import { icon_swap_calls } from './communication/swap_calls.icon';
import { icon_textsms } from './communication/textsms.icon';
import { icon_stop_screen_share } from './communication/stop_screen_share.icon';
import { icon_vpn_key } from './communication/vpn_key.icon';
import { icon_voicemail } from './communication/voicemail.icon';
var icons = {
  "business" : icon_business,
"call" : icon_call,
"call_end" : icon_call_end,
"call_merge" : icon_call_merge,
"call_made" : icon_call_made,
"call_missed" : icon_call_missed,
"call_missed_outgoing" : icon_call_missed_outgoing,
"call_received" : icon_call_received,
"chat" : icon_chat,
"chat_bubble_outline" : icon_chat_bubble_outline,
"chat_bubble" : icon_chat_bubble,
"call_split" : icon_call_split,
"contact_phone" : icon_contact_phone,
"comment" : icon_comment,
"dialer_sip" : icon_dialer_sip,
"email" : icon_email,
"contacts" : icon_contacts,
"dialpad" : icon_dialpad,
"import_contacts" : icon_import_contacts,
"contact_mail" : icon_contact_mail,
"clear_all" : icon_clear_all,
"forum" : icon_forum,
"import_export" : icon_import_export,
"location_on" : icon_location_on,
"invert_colors_off" : icon_invert_colors_off,
"live_help" : icon_live_help,
"mail_outline" : icon_mail_outline,
"message" : icon_message,
"phone" : icon_phone,
"no_sim" : icon_no_sim,
"location_off" : icon_location_off,
"phonelink_setup" : icon_phonelink_setup,
"phonelink_erase" : icon_phonelink_erase,
"phonelink_ring" : icon_phonelink_ring,
"present_to_all" : icon_present_to_all,
"phonelink_lock" : icon_phonelink_lock,
"ring_volume" : icon_ring_volume,
"portable_wifi_off" : icon_portable_wifi_off,
"rss_feed" : icon_rss_feed,
"stay_current_portrait" : icon_stay_current_portrait,
"screen_share" : icon_screen_share,
"speaker_phone" : icon_speaker_phone,
"stay_current_landscape" : icon_stay_current_landscape,
"stay_primary_landscape" : icon_stay_primary_landscape,
"stay_primary_portrait" : icon_stay_primary_portrait,
"swap_calls" : icon_swap_calls,
"textsms" : icon_textsms,
"stop_screen_share" : icon_stop_screen_share,
"vpn_key" : icon_vpn_key,
"voicemail" : icon_voicemail,
};
export { icons };
